import React, { useEffect, useMemo, useState } from "react";
import { Controller, type Control } from "react-hook-form";
import { Select } from "antd";
import useFilter from "../../hooks/students/useFilterStudents";
import { CaUserAcademy } from "../../../../types/dto/program";
import { usersService } from "../../../../shared/services";
import { useUsers } from "../../../users/hooks/useUsers";

const useDebounce = (cb: () => void, deps: unknown[], delay = 500) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      cb();
    }, delay);
    return () => clearTimeout(timeout);
  }, deps);
};

export default function AssignedTeacherProgramForm({
  control,
  programId,
}: {
  control: Control<any>;
  programId: number;
}) {
  const [teacherSearchValue, setTeacherSearchValue] = useState("");
  const { teacherWithoutPrograms, teacherWithoutProgramsQuery } = useUsers();

  useEffect(() => {
    if (programId) {
      teacherWithoutProgramsQuery(+programId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId]);

  const clientQuery = React.useMemo(
    () => ({ teacherWithoutPrograms: programId }),
    [programId]
  );

  const { setQuery, filteredData, loading } = useFilter<CaUserAcademy>({
    service: usersService,
    initialData: teacherWithoutPrograms,
    student_teacher: "teacher",
    clientQuery,
  });

  useDebounce(() => {
    setQuery(teacherSearchValue);
  }, [teacherSearchValue]);

  const uniqueTeachers = useMemo(
    () =>
      Array.from(
        new Map(filteredData.map((teacher) => [teacher.id, teacher])).values()
      ),
    [filteredData]
  );

  return (
    <div className="flex flex-col gap-2">
      <label>
        <strong>Selecciona un profesor</strong>
      </label>
      <Controller
        control={control}
        name="user_id"
        render={({ field, fieldState }) => (
          <div>
            <Select
              {...field}
              loading={loading}
              showSearch
              filterOption={false}
              style={{ width: "100%", height: 30 }}
              placeholder="Selecciona un profesor"
              onSearch={(value) => setTeacherSearchValue(value)}
              options={
                uniqueTeachers.length > 0
                  ? uniqueTeachers.map((teacher) => ({
                      key: `teacher-${teacher.id}`,
                      value: String(teacher.id),
                      label: `${teacher.first_name} ${teacher.last_name}`,
                    }))
                  : [
                      {
                        key: "",
                        value: "",
                        label: "No hay profesores disponibles",
                      },
                    ]
              }
            />
            {fieldState.error ? (
              <span className="mt-1 block text-xs text-red-500">
                {fieldState.error.message}
              </span>
            ) : null}
          </div>
        )}
      />
    </div>
  );
}
